/* @flow */

import React, { PureComponent } from 'react';
import {
  View,
} from 'react-native';

//Modules
import { Helmet } from "react-helmet";
import MainStyles from '../../helpers/mainstyles.js'

export default class MyComponent extends PureComponent {
  //Setup
  constructor(props){
    super(props);
    this.state = {
      title:this.props.title,
      description:this.props.description
    }
  }

  async componentDidMount(){
    this.setState({
      title:this.props.title,
      description:this.props.description,
      loading:false,
    })
  }

  async componentDidUpdate(prevProps){
    if(prevProps.title !== this.props.title){
      this.setState({title:this.props.title})
    }
    if(prevProps.description !== this.props.description){
      this.setState({description:this.props.description})
    }
  }

  async componentWillUnmount(){

  }

  renderContent = () => {
    var { title, description, loading } = this.state

    return(
      <>
      <View style={[{position:'absolute', opacity:0}, MainStyles.flexCenterStart]}>
        <h1>
        {title}
        </h1>
      </View>
      {
        <>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta property="description" content={description}/>
          <meta name="robots" content="NOODP,index,follow" />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta name="copyright" content="Copyright (c) 2021-2022 TNNS App Inc" />
          <meta name="keywords" content="live tennis scores, tennis scores, tennis results, live tennis, tennis streams, atp tour, wta tour, itf, utr tennis, australian open results" />
          <meta property="og:title" content="Live Tennis Scores, Schedules & Streams - ATP, WTA, Challenger & ITF - TNNS" />
        	<meta property="al:ios:app_store_id" content="1547205724" />
        	<meta property="al:ios:app_name" content="TNNS: Tennis Live Scores" />
        	<meta property="al:android:package" content="com.tennisrn" />
        	<meta property="al:android:app_name" content="TNNS: Tennis Live Scores" />
        	<meta property="og:site_name" content="TNNS: Tennis Live Scores" />
        	<meta name="apple-itunes-app" content="app-id=1547205724" />
        	<meta name="google-play-app" content="app-id=com.tennisrn" />
          <meta name="author" content="TNNS Live - tnnslive.com" />
        </Helmet>
        </>
      }
      </>
    )
  }

  render = () => {
    var { loading } = this.state
    try{
      return loading ? null : this.renderContent()
    }catch(e){
      return null
    }
  }

}
